export const CHECKOUT_URL = 'https://metodo-longevidad-canina.impultienda.ar/checkout'
export const PRICE = '$19.990'

export type PackItem = {
  tag: string
  title: string
  description: string
}

export const packItems: PackItem[] = [
  {
    tag: 'Guía Maestra',
    title: 'La Biblia de la Longevidad Canina',
    description:
      'El ebook central del método: el paso a paso completo para activar el "Interruptor de Longevidad" de tu perro.',
  },
  {
    tag: 'Bono 1',
    title: 'Farmacia en Casa',
    description:
      'Remedios naturales para los problemas más comunes, con lo que ya tienes en tu cocina.',
  },
  {
    tag: 'Bono 2',
    title: 'Protocolo de 24 Horas',
    description:
      'La desintoxicación inicial para bajar la inflamación silenciosa desde el primer día.',
  },
  {
    tag: 'Bono 3',
    title: 'El Comprador Biohacker',
    description:
      'Guía de etiquetas: qué ingredientes evitar y cómo elegir sin gastar de más.',
  },
  {
    tag: 'Bono 4',
    title: 'Calendario de Hábitos de 7 Minutos',
    description:
      'Un plan diario simple para que el método se vuelva automático en tu rutina.',
  },
  {
    tag: 'Bono 5',
    title: 'Cocina que Cura',
    description:
      'Recetario de premios caseros que refuerzan sus articulaciones, su pelaje y su digestión.',
  },
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Tengo que cocinarle comida natural todos los días?',
    answer:
      'No. El método está diseñado para optimizar el alimento que ya le das, agregando potenciadores biológicos en segundos.',
  },
  {
    question: '¿Es seguro para cachorros o perros ancianos?',
    answer:
      'Es vital para ambos. A los cachorros les da una base celular fuerte y a los ancianos les devuelve la movilidad.',
  },
  {
    question: '¿Tengo que comprar suplementos caros?',
    answer:
      'Para nada. La mayoría de los "biohacks" usan ingredientes que ya tienes en tu alacena (como cúrcuma, aceite de coco o vinagre).',
  },
]

export const painPoints: string[] = [
  'Apaga el brillo de su pelaje y su energía.',
  'Destruye sus articulaciones antes de tiempo.',
  'Crea una dependencia costosa de visitas al veterinario.',
]

export const symptoms: string[] = [
  'Mal aliento',
  'Se rasca constantemente',
  'Le falta energía',
  'Problemas digestivos',
]
